(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.staffresponsibilitytx = skyward.staffresponsibilitytx || {};

        var init = function (selector)
        {
            var detailsScreenSelector = $(selector).find("#editStaffResponsibilityTX.currentRecordContent.dataObjectViewer");
            var workflowScreenSelector = $(selector).filter(".workflowContent");
            var entityCodeEel;
            var roleCodeEel;
            var stateServiceIDCodeEel;
            var localServiceIDCodeEel;
            var courseCodeEel;
            var sectionCodeEel;
            var populationServedCodeEel;
            var uniqueSectionRadioButtonGroup;
            var numberOfStudentsTextBox;
            var pageSelector;
            var isDetails;

            if (detailsScreenSelector.length > 0)
            {
                entityCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_EntityID");
                roleCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StateRoleTXID");
                stateServiceIDCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StateServiceIDTXID");
                localServiceIDCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_LocalServiceIDTXID");
                courseCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_CourseID");
                sectionCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_SectionID");
                populationServedCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StatePopulationServedTXID");
                uniqueSectionRadioButtonGroup = detailsScreenSelector.find("#editStaffResponsibilityTX_UniqueSectionCodeOptionSelected_RadioButtonGroup");
                numberOfStudentsTextBox = detailsScreenSelector.find("#editStaffResponsibilityTX_NumberOfStudentsInClass");
                isDetails = true;
                pageSelector = "#editStaffResponsibilityTX_";
            }
            else if (workflowScreenSelector.length > 0)
            {
                entityCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXEntityID");
                roleCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStateRoleTXID");
                stateServiceIDCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStateServiceIDTXID");
                localServiceIDCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXLocalServiceIDTXID");
                courseCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXCourseID");
                sectionCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXSectionID");
                populationServedCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStatePopulationServedTXID");
                uniqueSectionRadioButtonGroup = workflowScreenSelector.find("#UniqueSectionCodeOptionSelected");
                numberOfStudentsTextBox = workflowScreenSelector.find("#StaffResponsibilityTXNumberOfStudentsInClass");
                isDetails = false;
                pageSelector = "#StaffResponsibilityTX";
            }
            else
            {
                return;
            }

            var entityCodeEelOnChange = function ()
            {
                skyward.staffresponsibilitytx.handleEntityChange(pageSelector, isDetails);
            };
            entityCodeEel.on("change", entityCodeEelOnChange);

            var roleCodeEelOnChange = function ()
            {
                skyward.staffresponsibilitytx.handleRoleChange(true);
            };
            roleCodeEel.on("eelComplete", roleCodeEelOnChange);

            var uniqueSectionCodeChange = function ()
            {
                skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection(pageSelector, false, isDetails);
            };
            uniqueSectionRadioButtonGroup.on("change", uniqueSectionCodeChange);

            if (isDetails)
            {
                skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection(pageSelector, true, isDetails);
            }

            var courseCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handleCourseEelComplete(pageSelector, isDetails);
            };
            courseCodeEel.on("eelComplete", courseCodeEelComplete);

            var sectionCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handleSectionEelComplete(pageSelector, isDetails);
            };
            sectionCodeEel.on("eelComplete", sectionCodeEelComplete);

            var populationServedCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handlePopulationServedEelComplete(pageSelector, isDetails);
            };
            populationServedCodeEel.on("eelComplete", populationServedCodeEelComplete);

            var stateServiceIDCodeEelComplete = function () {
                skyward.staffresponsibilitytx.handleStateServiceIDEelComplete(pageSelector, isDetails);
            };
            stateServiceIDCodeEel.on("eelComplete", stateServiceIDCodeEelComplete);

            var localServiceIDCodeEelComplete = function () {
                skyward.staffresponsibilitytx.handleLocalServiceIDEelComplete(pageSelector, isDetails);
            };
            localServiceIDCodeEel.on("eelComplete", localServiceIDCodeEelComplete);

            var numberOfStudentsChange = function () {
                skyward.staffresponsibilitytx.handleNumberOfStudentsChange(pageSelector, isDetails);
            };
            numberOfStudentsTextBox.on("change", numberOfStudentsChange);
        };

        skyward.staffresponsibilitytx.handleEntityChange = function (pageSelector, isDetails)
        {
            var staffRoleCodeEelValue = $(pageSelector + "StateRoleTXID_code").val();;

            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");

            if (staffRoleCodeEelValue == "002" || staffRoleCodeEelValue == "007" || staffRoleCodeEelValue == "015" || staffRoleCodeEelValue === "016" || staffRoleCodeEelValue === "017" ||
                staffRoleCodeEelValue === "018" || staffRoleCodeEelValue === "021" || staffRoleCodeEelValue === "026" || staffRoleCodeEelValue === "032" || staffRoleCodeEelValue === "033" ||
                staffRoleCodeEelValue === "036" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087") 
            {
                uniqueSectionRadioButtonGroup.change();
            }
        };

        skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection = function (pageSelector, isOnLoad, isDetails)
        {
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            var entityEelID = $(pageSelector + "EntityID_value");

            var courseID = $(pageSelector + "CourseID");
            var courseEelCode = $(pageSelector + "CourseID_code");
            var courseEelDescription = $(pageSelector + "CourseID_description");
            var courseEelID = $(pageSelector + "CourseID_value");

            var sectionID = $(pageSelector + "SectionID");
            var sectionEelCode = $(pageSelector + "SectionID_code");
            var sectionEelDescription = $(pageSelector + "SectionID_description");
            var sectionEelID = $(pageSelector + "SectionID_value");

            var selectEntityLabel = isDetails ? $(pageSelector + "selectEntity") : $("#selectEntity");
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var courseCodeEel = isDetails ? $(pageSelector + "fsCourseID") : $("#fsCourseID");
            var sectionCodeEel = isDetails ? $(pageSelector + "fsSectionID") : $("#fsSectionID");
            var selectCourseLabel = isDetails ? $(pageSelector + "selectCourse") : $("#selectCourse");

            if (!isOnLoad)
            {
                uniqueSectionCode.val("");

                courseEelCode.val("");
                courseEelDescription.val("");
                courseEelID.val("");

                sectionEelCode.val("");
                sectionEelDescription.val("");
                sectionEelID.val("");
            }

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (isOnLoad)
                {
                    selectSectionLabel.hide();
                    uniqueSectionCode.show();
                    sectionID.show();
                    selectCourseLabel.hide();
                }
                else
                {
                    selectSectionLabel.show();
                    uniqueSectionCode.hide();
                    sectionID.hide();
                    selectCourseLabel.show();
                }

                uniqueSectionCode.attr("readOnly", true);
                courseCodeEel.show();
                sectionCodeEel.show();

                if (entityEelID.val() != "")
                {
                    courseID.show();
                    selectEntityLabel.hide();
                }
                else
                {
                    courseID.hide();
                    selectEntityLabel.show();
                }
            }
            else
            {
                selectSectionLabel.hide();
                uniqueSectionCode.show();
                courseCodeEel.hide();
                sectionCodeEel.hide();
            }
        };

        skyward.staffresponsibilitytx.handleCourseEelComplete = function (pageSelector, isDetails)
        {
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var courseEelID = $(pageSelector + "CourseID_value");

            var sectionID = $(pageSelector + "SectionID");
            var sectionEelCode = $(pageSelector + "SectionID_code");
            var sectionEelDescription = $(pageSelector + "SectionID_description");
            var sectionEelID = $(pageSelector + "SectionID_value");
            var selectCourseLabel = isDetails ? $(pageSelector + "selectCourse") : $("#selectCourse");

            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (courseEelID.val() == "")
                {
                    selectCourseLabel.show();
                    sectionID.hide();
                }
                else
                {
                    selectCourseLabel.hide();
                    sectionID.show();
                }

                sectionEelCode.val("");
                sectionEelDescription.val("");
                sectionEelID.val("");

                selectSectionLabel.show();
                uniqueSectionCode.hide();
                uniqueSectionCode.val("");
            }
            else
            {
                selectSectionLabel.hide();
            }
        };

        skyward.staffresponsibilitytx.handleSectionEelComplete = function (pageSelector, isDetails)
        {
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var sectionEelID = $(pageSelector + "SectionID_value");
            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (sectionEelID.val() == "")
                {
                    selectSectionLabel.show();
                    uniqueSectionCode.hide();
                    uniqueSectionCode.val("");
                }
                else
                {
                    selectSectionLabel.hide();
                    uniqueSectionCode.show();
                }
            }
            else
            {
                selectSectionLabel.hide();
            }
        };

        skyward.staffresponsibilitytx.handlePopulationServedEelComplete = function (pageSelector, isDetails)
        {
            var roleCodeEelValue = $(pageSelector + "StateRoleTXID_code").val();
            var populationServedCodeEelValue = $(pageSelector + "StatePopulationServedTXID_code").val();

            var gradeLevelCodeEel = isDetails ? $(pageSelector + 'fsGradeLevelID') : $("#fsGradeLevelID");
            var gradeLevelCodeEelCodeValue = $(pageSelector + 'StateGradeLevelTXID_code');
            var gradeLevelCodeEelDescriptionValue = $(pageSelector + 'StateGradeLevelTXID_description');
            var gradeLevelCodeEelID = $(pageSelector + 'StateGradeLevelTXID_value');

            var sPEDStudentAgeRangeCodeEel = isDetails ? $(pageSelector + 'fsEdFiTXSPEDStudentAgeRangeDescriptor') : $("#fsEdFiTXSPEDStudentAgeRangeDescriptor");
            var sPEDStudentAgeRangeeCodeEelCodeValue = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
            var sPEDStudentAgeRangeCodeEelDescriptionValue = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
            var sPEDStudentAgeRangeCodeEelID = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

            if ((roleCodeEelValue === "033" || roleCodeEelValue === "047" || roleCodeEelValue === "087") && populationServedCodeEelValue === "06")
            {
                gradeLevelCodeEel.show();
                sPEDStudentAgeRangeCodeEel.show();
            }
            else
            {
                gradeLevelCodeEel.hide();
                gradeLevelCodeEelCodeValue.val("");
                gradeLevelCodeEelDescriptionValue.val("");
                gradeLevelCodeEelID.val("");

                sPEDStudentAgeRangeCodeEel.hide();
                sPEDStudentAgeRangeeCodeEelCodeValue.val("");
                sPEDStudentAgeRangeCodeEelDescriptionValue.val("");
                sPEDStudentAgeRangeCodeEelID.val("");
            }
        };

        skyward.staffresponsibilitytx.handleRoleChange = function (clearFields)
        {
            var staffRoleCodeEelValue;
            var staffPopulationServedCodeEelValue;

            var courseCodeEel;
            var courseEelCodeValue;
            var courseEelDescriptionValue;
            var courseEelID;

            var sectionCodeEel;
            var sectionEelCodeValue;
            var sectionEelDescriptionValue;
            var sectionEelID;

            var classTypeCodeEel;
            var classTypeCodeEelCodeValue;
            var classTypeCodeEelDescriptionValue;
            var classTypeCodeEelID;

            var sPEDStudentAgeRangeCodeEel;
            var sPEDStudentAgeRangeeCodeEelCodeValue;
            var sPEDStudentAgeRangeCodeEelDescriptionValue;
            var sPEDStudentAgeRangeCodeEelID;

            var gradeLevelCodeEel;
            var gradeLevelCodeEelCodeValue;
            var gradeLevelCodeEelDescriptionValue;
            var gradeLevelCodeEelID;

            var additionalDaysProgramTeacherIndicator
            var additionalDaysProgramTeacherIndicatorValue

            var uniqueSectionCodeRadioSet;
            var uniqueSectionCodeSelectCourseRadioButton;

            var classIDNumber;
            var classIDNumberValue;

            var monthlyMinutes;
            var monthlyMinutesValue;

            var numberOfStudents;
            var numberOfStudentsValue;

            var isWorkflow;
            var staffRoleCodeEeLIsDirty;

            if ($("#editStaffResponsibilityTX_StateRoleTXID_code").length > 0)
            {
                var detailsEditScreenSelector = '#editStaffResponsibilityTX_';
                isWorkflow = false;

                staffRoleCodeEelValue = $(detailsEditScreenSelector + "StateRoleTXID_code").val();
                staffRoleCodeEeLIsDirty = $(detailsEditScreenSelector + "StateRoleTXID_value").attr("data-dirty");

                courseCodeEel = $(detailsEditScreenSelector + 'fsCourseID');
                courseEelCodeValue = $(detailsEditScreenSelector + 'CourseID_code');
                courseEelDescriptionValue = $(detailsEditScreenSelector + 'CourseID_description');
                courseEelID = $(detailsEditScreenSelector + 'CourseID_value');

                sectionCodeEel = $(detailsEditScreenSelector + 'fsSectionID');
                sectionEelCodeValue = $(detailsEditScreenSelector + 'SectionID_code');
                sectionEelDescriptionValue = $(detailsEditScreenSelector + 'SectionID_description');
                sectionEelID = $(detailsEditScreenSelector + 'SectionID_value');

                classTypeCodeEel = $(detailsEditScreenSelector + 'fsClassTypeID');
                classTypeCodeEelCodeValue = $(detailsEditScreenSelector + 'StateClassTypeTXID_code');
                classTypeCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateClassTypeTXID_description');
                classTypeCodeEelID = $(detailsEditScreenSelector + 'StateClassTypeTXID_value');

                sPEDStudentAgeRangeCodeEel = $(detailsEditScreenSelector + 'fsEdFiTXSPEDStudentAgeRangeDescriptor');
                sPEDStudentAgeRangeeCodeEelCodeValue = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
                sPEDStudentAgeRangeCodeEelDescriptionValue = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
                sPEDStudentAgeRangeCodeEelID = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

                staffPopulationServedCodeEelValue = $(detailsEditScreenSelector + "StatePopulationServedTXID_code").val();

                gradeLevelCodeEel = $(detailsEditScreenSelector + 'fsGradeLevelID');
                gradeLevelCodeEelCodeValue = $(detailsEditScreenSelector + 'StateGradeLevelTXID_code');
                gradeLevelCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateGradeLevelTXID_description');
                gradeLevelCodeEelID = $(detailsEditScreenSelector + 'StateGradeLevelTXID_value');

                additionalDaysProgramTeacherIndicator = $(detailsEditScreenSelector + 'fsAdditionalDaysProgramTeacherIndicator');
                additionalDaysProgramTeacherIndicatorValue = $(detailsEditScreenSelector + 'AdditionalDaysProgramTeacherIndicator');

                uniqueSectionCodeRadioSet = $(detailsEditScreenSelector + 'fsUniqueSectionCodeSelector');
                uniqueSectionCodeSelectCourseRadioButton = $(detailsEditScreenSelector + 'UniqueSectionCodeOptionSelected');

                classIDNumber = $(detailsEditScreenSelector + 'fsUniqueSectionCode');
                classIDNumberValue = $(detailsEditScreenSelector + 'UniqueSectionCode');

                monthlyMinutes = $(detailsEditScreenSelector + 'fsMonthlyMinutes');
                monthlyMinutesValue = $(detailsEditScreenSelector + 'MonthlyMinutes');

                numberOfStudents = $(detailsEditScreenSelector + 'fsNumberStudentsInClass');
                numberOfStudentsValue = $(detailsEditScreenSelector + 'NumberOfStudentsInClass');
            }
            else if ($("#StaffResponsibilityTXStateRoleTXID_code").length > 0)
            {
                var workflowScreenSelector = '#StaffResponsibilityTX';
                isWorkflow = true;

                staffRoleCodeEelValue = $(workflowScreenSelector + "StateRoleTXID_code").val();
                staffRoleCodeEeLIsDirty = true;

                courseCodeEel = $('#fsCourseID');
                courseEelCodeValue = $(workflowScreenSelector + 'CourseID_code');
                courseEelDescriptionValue = $(workflowScreenSelector + 'CourseID_description');
                courseEelID = $(workflowScreenSelector + 'CourseID_value');

                sectionCodeEel = $('#fsSectionID');
                sectionEelCodeValue = $(workflowScreenSelector + 'SectionID_code');
                sectionEelDescriptionValue = $(workflowScreenSelector + 'SectionID_description');
                sectionEelID = $(workflowScreenSelector + 'SectionID_value');

                classTypeCodeEel = $('#fsClassTypeID');
                classTypeCodeEelCodeValue = $(workflowScreenSelector + 'StateClassTypeTXID_code');
                classTypeCodeEelDescriptionValue = $(workflowScreenSelector + 'StateClassTypeTXID_description');
                classTypeCodeEelID = $(workflowScreenSelector + 'StateClassTypeTXID_value');

                sPEDStudentAgeRangeCodeEel = $('#fsEdFiTXSPEDStudentAgeRangeDescriptor');
                sPEDStudentAgeRangeeCodeEelCodeValue = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
                sPEDStudentAgeRangeCodeEelDescriptionValue = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
                sPEDStudentAgeRangeCodeEelID = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

                staffPopulationServedCodeEelValue = $(workflowScreenSelector + "StatePopulationServedTXID_code").val();

                gradeLevelCodeEel = $('#fsGradeLevelID');
                gradeLevelCodeEelCodeValue = $(workflowScreenSelector + 'StateGradeLevelTXID_code');
                gradeLevelCodeEelDescriptionValue = $(workflowScreenSelector + 'StateGradeLevelTXID_description');
                gradeLevelCodeEelID = $(workflowScreenSelector + 'StateGradeLevelTXID_value');

                additionalDaysProgramTeacherIndicator = $('#fsAdditionalDaysProgramTeacherIndicator');
                additionalDaysProgramTeacherIndicatorValue = $(workflowScreenSelector + 'AdditionalDaysProgramTeacherIndicator');

                uniqueSectionCodeRadioSet = $('#fsUniqueSectionCodeSelector');
                uniqueSectionCodeSelectCourseRadioButton = $('#UniqueSectionCodeOptionSelected');

                classIDNumber = $('#fsUniqueSectionCode');
                classIDNumberValue = $(workflowScreenSelector + 'UniqueSectionCode');

                monthlyMinutes = $('#fsMonthlyMinutes');
                monthlyMinutesValue = $(workflowScreenSelector + 'MonthlyMinutes');

                numberOfStudents = $('#fsNumberStudentsInClass');
                numberOfStudentsValue = $(workflowScreenSelector + 'NumberOfStudentsInClass');
            }
            else
            {
                return;
            }

            if (staffRoleCodeEelValue.length > 0 && staffRoleCodeEeLIsDirty != undefined && staffRoleCodeEeLIsDirty)
            {
                skyward.staffresponsibilitytx.SetServiceID(staffRoleCodeEelValue, isWorkflow);

                if (staffRoleCodeEelValue === "002" || staffRoleCodeEelValue === "007" || staffRoleCodeEelValue === "015" || staffRoleCodeEelValue === "016" || staffRoleCodeEelValue === "017" ||
                    staffRoleCodeEelValue === "018" || staffRoleCodeEelValue === "021" || staffRoleCodeEelValue === "026" || staffRoleCodeEelValue === "032" || staffRoleCodeEelValue === "033" ||
                    staffRoleCodeEelValue === "036" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087")
                {
                    classTypeCodeEel.css('display', 'block');
                    courseCodeEel.css('display', 'block');
                    sectionCodeEel.css('display', 'block');
                    uniqueSectionCodeRadioSet.css('display', 'block');
                    classIDNumber.css('display', 'block');
                    monthlyMinutes.css('display', 'block');
                    numberOfStudents.css('display', 'block');

                    uniqueSectionCodeSelectCourseRadioButton.change();
                }
                else
                {
                    classTypeCodeEel.css('display', 'none');
                    courseCodeEel.css('display', 'none');
                    sectionCodeEel.css('display', 'none');
                    uniqueSectionCodeRadioSet.css('display', 'none');
                    classIDNumber.css('display', 'none');
                    numberOfStudents.css('display', 'none');

                    if (staffRoleCodeEelValue === "008")
                    {
                        monthlyMinutes.css('display', 'block');
                    }
                    else
                    {
                        monthlyMinutes.css('display', 'none');
                    }
                }

                if ((staffRoleCodeEelValue === "033" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087") && staffPopulationServedCodeEelValue === "06")
                {
                    gradeLevelCodeEel.css('display', 'block');
                    sPEDStudentAgeRangeCodeEel.css('display', 'block');
                }
                else
                {
                    gradeLevelCodeEel.css('display', 'none');
                    sPEDStudentAgeRangeCodeEel.css('display', 'none');
                }

                if (staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087")
                {
                    additionalDaysProgramTeacherIndicator.css('display', 'block');
                }
                else
                {
                    additionalDaysProgramTeacherIndicator.css('display', 'none');
                }

                if (clearFields)
                {
                    skyward.controls.setValue(classTypeCodeEelCodeValue, "");
                    skyward.controls.setValue(classTypeCodeEelDescriptionValue, "");
                    skyward.controls.setValue(classTypeCodeEelID, "");

                    skyward.controls.setValue(sPEDStudentAgeRangeeCodeEelCodeValue, "");
                    skyward.controls.setValue(sPEDStudentAgeRangeCodeEelDescriptionValue, "");
                    skyward.controls.setValue(sPEDStudentAgeRangeCodeEelID, "");

                    skyward.controls.setValue(courseEelCodeValue, "");
                    skyward.controls.setValue(courseEelDescriptionValue, "");
                    skyward.controls.setValue(courseEelID, "");

                    skyward.controls.setValue(sectionEelCodeValue, "");
                    skyward.controls.setValue(sectionEelDescriptionValue, "");
                    skyward.controls.setValue(sectionEelID, "");

                    skyward.controls.setValue(classIDNumberValue, "");

                    skyward.controls.setValue(gradeLevelCodeEelCodeValue, "");
                    skyward.controls.setValue(gradeLevelCodeEelDescriptionValue, "");
                    skyward.controls.setValue(gradeLevelCodeEelID, "");

                    skyward.controls.setValue(additionalDaysProgramTeacherIndicatorValue, false);

                    skyward.controls.setValue(monthlyMinutesValue, 0);

                    skyward.controls.setValue(numberOfStudentsValue, 0);
                }
            }
        };

        skyward.staffresponsibilitytx.SetServiceID = function (role, isWorkflow)
        {
            var screen;
            if (isWorkflow)
            {
                screen = 'Workflow';
            }
            else
            {
                screen = 'Details';
            }

            $.ajax({
                url: skyward.global.virtualDir + 'Demographics/StaffResponsibilityTX/SetServiceIDOn' + screen,
                type: "POST",
                dataType: "JSON",
                data: { Role: role },
                success: function (data)
                {
                    if (data && data.success)
                    {
                        if (isWorkflow)
                        {
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID"), data.serviceID);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_value"), data.serviceID);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_code"), data.serviceCode);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_description"), data.serviceDescription);
                            $("#ServiceIDSelected_1").prop("checked", true);
                            $("#ServiceIDSelected_1").change();
                        }
                        else
                        {
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID"), data.serviceID);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_value"), data.serviceID);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_code"), data.serviceCode);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_description"), data.serviceDescription);
                            $("#editStaffResponsibilityTX_ServiceIDSelected_1").prop("checked", true);
                            $("#editStaffResponsibilityTX_ServiceIDSelected_1").change();
                        }
                    }
                }
            });
        };

        skyward.staffresponsibilitytx.handleStateServiceIDEelComplete = function (pageSelector, isDetails) {
            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, true);
        }

        skyward.staffresponsibilitytx.handleLocalServiceIDEelComplete = function (pageSelector, isDetails) {
            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, false);
        }

        skyward.staffresponsibilitytx.handleNumberOfStudentsChange = function (pageSelector, isDetails) {
            var isStateServiceID;

            var localServiceIDRadioButton = isDetails ? $(pageSelector + "ServiceIDSelected") : $("#ServiceIDSelected");
            isStateServiceID = localServiceIDRadioButton.val() === "StateServiceIDTX"; // LocalServiceID

            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, isStateServiceID);
        }

        skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught = function (pageSelector, isDetails, isStateServiceID) {
            var serviceIDValue;

            if (isStateServiceID) {
                serviceIDValue = $(pageSelector + 'StateServiceIDTXID_code').val();
            }
            else {
                serviceIDValue = $(pageSelector + 'LocalServiceIDTXID_code').val();
            }

            var numberOfStudentsInClassValue = $(pageSelector + 'NumberOfStudentsInClass').val();
            var divNumberDaysMinutesTaught = isDetails ? $(pageSelector + 'divNumberDaysMinutesTaught') : $("#divNumberDaysMinutesTaught");

            if (numberOfStudentsInClassValue > 0 &&
                   (serviceIDValue === "02530002" || serviceIDValue === "02530003" || serviceIDValue === "02530004" || serviceIDValue === "02530005" || serviceIDValue === "02530006" || serviceIDValue === "02530007" || serviceIDValue === "02530008" ||
                    serviceIDValue === "02850000" || serviceIDValue === "03823000" || serviceIDValue === "PES00052" || serviceIDValue === "PES00053" || serviceIDValue === "PES00054" || serviceIDValue === "PES00055" || serviceIDValue === "82210XXX" ||
                    serviceIDValue === "82931XXX" || serviceIDValue === "83210XXX" || serviceIDValue === "84200XXX")) {
                divNumberDaysMinutesTaught.show();
            }
            else {
                divNumberDaysMinutesTaught.hide();

                for (var i = 1; i <= 4; i++) {
                    if (isDetails) {
                        $(pageSelector + 'NumberDaysTaughtWeek' + i).val("");
                        $(pageSelector + 'NumberMinutesTaughtWeek' + i).val("");
                    }
                    else {
                        $('#NumberDaysTaughtWeek' + i).val("");
                        $('#NumberMinutesTaughtWeek' + i).val("");
                    }
                }
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);